/**
 * app.js
 *
 * This is the entry file for the application, only setup and boilerplate
 * code.
 */

// Import all the third party stuff
import React from "react";
import ReactDOM from "react-dom";
import Amplify, { Analytics } from "aws-amplify";

import "@aws-amplify/ui-react/styles.css";

// Import root app
import App from "containers/App";

import { awsConfig } from "./aws-config";

import "assets/scss/material-kit-pro-react.scss?v=1.3.0";
import RootStore from "./mobX/RootStore";
import { GraphqlApi } from "./graphql/api";
import { RootStoreContext } from "./mobX/RootStore";
import { BrowserRouter } from "react-router-dom";

const MOUNT_NODE = document.getElementById("app");

Amplify.configure(awsConfig());

Analytics.autoTrack("pageView", {
	enable: true,
	eventName: "pageView",
	getUrl: () => window.location.origin + window.location.pathname,
});

const transportLayer = new GraphqlApi();
const rootStore = new RootStore(transportLayer);

ReactDOM.render(
	<BrowserRouter>
		<RootStoreContext.Provider value={rootStore}>
			<App />
		</RootStoreContext.Provider>
	</BrowserRouter>,
	MOUNT_NODE,
);
